import { useCallback } from 'react';
import { useAsyncData } from './useAsyncData';
import { useAuth } from './useAuth';
import { feedbackAPI, type FeedbackStatus, type FeedbackSubmitPayload } from '@/services/api/feedback.api';

/**
 * useFeedbackSurveyTrigger
 * Lee del backend si debe mostrarse el cuestionario de feedback (≥2 días con
 * actividad, no completado, no mostrado hoy, con reintento único) y expone las
 * acciones de marcar-mostrado y enviar. Toda la lógica de umbral/cadencia vive
 * en el backend; el cliente solo respeta el flag `show`.
 */
export function useFeedbackSurveyTrigger() {
  const { user } = useAuth();
  const isStudent = user?.role === 'student';

  const status = useAsyncData<FeedbackStatus>({
    fetchFn: () => feedbackAPI.getStatus(),
    enabled: isStudent,
    dependencies: [user?.id],
  });

  const markShown = useCallback(() => feedbackAPI.markShown(), []);
  const submit = useCallback(
    (payload: FeedbackSubmitPayload) => feedbackAPI.submit(payload),
    []
  );

  return {
    show: status.data?.show ?? false,
    isLoading: status.isLoading,
    markShown,
    submit,
  };
}
